import React,{ useState, useEffect } from 'react';
import {
    Button
} from 'antd';

import {
    PhoneOutlined,
    MessageOutlined,
    RightOutlined
} from '@ant-design/icons';

function SupportMenu() {
    return (
        <div className='default-menu-items support-menu-items'>
            <div className='support-team-cta-container support-state'>
                <h4>Need Support?</h4>
                <p>Our support team is here for timely solutions and guidance, keeping you connected seamlessly.</p>
                <div className='support-cta-button-container'>
                    <Button
                        className='tech-support-phone'
                        icon={ <PhoneOutlined /> }
                        type="primary"
                        href={ "tel:1-866-434-5888" }
                        style={ { 'marginRight' : '1rem' } }
                    > Call 1-866-434-5888</Button>
                </div>
                <span style={{ fontSize:'0.8rem' }}>Available between the hours of 8:00am - 9:00pm ET.</span>
            </div>
            <div className='support-links-container support-links'>
                <h4>Support Links</h4>
                <p>Check out our support pages and contact us if you still need help.</p>
                <a href="/support/support-videos">Support Videos <RightOutlined /></a>
                <a href="/support/startcare">Start Care <RightOutlined /></a>
                <a href="/support/support-videos">TV Support <RightOutlined /></a>
                <a href="/blog">Blog <RightOutlined /></a>
                <a href="/support/tools/quick-links-support-links">Quick Links <RightOutlined /></a>
            </div>
        </div>
    )
}

export default SupportMenu
